import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "columns", "showColumns", "dataSource"];
import React, { useEffect } from 'react';
import classnames from 'classnames';
import Content from '../Content';
import './index.less';

const getTypeGroup = (type, columns = []) => {
  return columns.reduce((res = [], item = {}) => {
    const {
      fields = []
    } = item;
    fields.forEach((field = {}) => {
      const {
        productType,
        dataType = []
      } = field;

      if (productType === type) {
        res.push(dataType);
      }
    });
    return res;
  }, []);
};

const getPartSource = (list = [], columns = []) => {
  return list.reduce((res = [], item = {}) => {
    const {
      planConfigLiabilityList = [],
      productType,
      productName,
      simpleRemark: productSampleDesc,
      sumInsuredValueStr: productSumInsuredValueStr,
      remark: productRemark
    } = item;
    const typeGroup = getTypeGroup(productType, columns);

    if (typeGroup[0][0] === 'product') {
      const curr = [];
      typeGroup.forEach((type = []) => {
        //
        const strs = [];
        type.forEach(currType => {
          let str;

          switch (currType) {
            case 'productSampleDesc':
              str = productSampleDesc; // `<div class="package-part">${productSampleDesc || ''}</div>`;

              break;

            case 'product':
              str = productName; // `<div class="package-part">${productName || ''}</div>`;

              break;

            case 'sumInsured':
            case 'limmit':
            case 'deductible':
              str = productSumInsuredValueStr || '';
              str = str.replace(/\d+\.{0,1}\d+/g, text => {
                const num = Number(text);

                if (Number.isNaN(num)) {
                  return text;
                }

                return num < 10000 ? `${num}` : `${num * 100 / 1000000}万`;
              });
              break;
          }

          strs.push(str);
        }); //
        // curr.push(strs[0])

        const text = strs.join('');
        text && curr.push(text);
      });
      curr.push(productRemark); //

      res.push(curr);
      return res;
    }

    planConfigLiabilityList.forEach((liability = {}) => {
      const {
        liabilityName,
        sumInsuredValueStr,
        simpleRemark,
        remark
      } = liability;
      const curr = [];
      typeGroup.forEach((type = []) => {
        const strs = [];
        type.forEach(currType => {
          let str;

          switch (currType) {
            case 'liability':
              str = liabilityName;
              break;

            case 'product':
              str = productName;
              break;

            case 'liabilitySampleDesc':
              str = simpleRemark;
              break;

            case 'sumInsured':
            case 'limmit':
            case 'deductible':
              str = sumInsuredValueStr || '';
              str = str.replace(/\d+\.{0,1}\d+/g, text => {
                const num = Number(text);

                if (Number.isNaN(num)) {
                  return text;
                }

                return num < 10000 ? `${num}` : `${num * 100 / 1000000}万`;
              });
              break;
          }

          strs.push(str);
        }); //

        const text = strs.join('') || '';
        curr.push(text); // curr.push(strs[0])
      });
      curr.push(remark);
      res.push(curr);
    });
    return res;
  }, []);
};

const getStatus = (value, showColumns = []) => {
  const curr = showColumns.find((item = {}) => item.value === value) || {};
  return curr.isDefault;
};

const renderBy = status => node => {
  return status ? node : null;
};

const GuaranteeDutyConfirm = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    children
  } = props;

  const {
    className,
    columns = [],
    showColumns = [],
    dataSource = {}
  } = attrs,
        others = _objectWithoutProperties(attrs, _excluded);

  const {
    serviceList = [],
    planConfigMainProductList = [],
    planConfigAdditionProductList = []
  } = dataSource;
  const cls = classnames({
    'components-guarantee-duty-confirm-render': true,
    [className]: !!className
  });
  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById('container');

      if (!element) {
        return;
      }

      element.scrollTop = 0.1;
    });
  }, []);

  const renderMain = () => {
    const mainStatus = getStatus('main', showColumns);
    const detailDescStatus = getStatus('detailDesc', showColumns);
    const data = getPartSource(planConfigMainProductList, columns) || [];

    if (!mainStatus) {
      return null;
    } // ;


    return data.map((item = [], index) => {
      const {
        length
      } = item; // const title = item.length > 2 ? item.slice(0, -2).join(' ') : '';
      // const desc = item[length - 2] || '';
      // const remark = item[length - 1] || '';

      const title = item[0] || '';
      const desc = item[1] || '';
      const remark = item[2] || '';
      const dangerouslySetInnerHTML = {
        __html: remark
      };
      const dangerouslySetInnerTitle = {
        __html: title
      };
      const dangerouslySetInnerDesc = {
        __html: desc
      };
      const bodyNode = renderBy(detailDescStatus && remark)( /*#__PURE__*/React.createElement(Content, {
        className: "item-body",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "confirm-item",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "item-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        dangerouslySetInnerHTML: dangerouslySetInnerTitle
      }), /*#__PURE__*/React.createElement("div", {
        className: "desc",
        dangerouslySetInnerHTML: dangerouslySetInnerDesc
      })), bodyNode);
    });
  };

  const renderAddition = () => {
    const additionStatus = getStatus('addition', showColumns);
    const detailDescStatus = getStatus('detailDesc', showColumns);
    const data = getPartSource(planConfigAdditionProductList, columns) || [];

    if (!additionStatus) {
      return null;
    }

    return data.map((item = [], index) => {
      // const title = item.slice(0, -2).join(' ');
      // const desc = item[length - 2] || '';
      // const remark = item[length - 1] || '';
      const title = item[0] || '';
      const desc = item[1] || '';
      const remark = item[2] || '';
      const dangerouslySetInnerHTML = {
        __html: remark
      };
      const bodyNode = renderBy(detailDescStatus && remark)( /*#__PURE__*/React.createElement(Content, {
        className: "item-body",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "confirm-item",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "item-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, title), /*#__PURE__*/React.createElement("div", {
        className: "desc"
      }, desc)), bodyNode);
    });
  };

  const renderService = () => {
    const serviceStatus = getStatus('service', showColumns);
    const moreIntrodutionStatus = getStatus('moreIntrodution', showColumns);
    const data = serviceList.map((item = {}) => {
      const {
        serviceShowName,
        serviceDescription,
        serviceRemark
      } = item;
      return [serviceShowName, serviceDescription, serviceRemark];
    });

    if (!serviceStatus) {
      return null;
    }

    return data.map((item = [], index) => {
      const [title, desc, remark] = item;
      const dangerouslySetInnerHTML = {
        __html: remark
      };
      const dangerouslySetInnerTitle = {
        __html: title
      };
      const bodyNode = renderBy(moreIntrodutionStatus && remark)( /*#__PURE__*/React.createElement(Content, {
        className: "item-body",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
      }));
      return /*#__PURE__*/React.createElement("div", {
        className: "confirm-item",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "item-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title",
        dangerouslySetInnerHTML: dangerouslySetInnerTitle
      }), /*#__PURE__*/React.createElement("div", {
        className: "desc"
      }, desc)), bodyNode);
    });
  };

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), renderMain(), renderAddition(), renderService());
});
export default GuaranteeDutyConfirm;